define('Components/InstagramWidget/js/models/InstagramWidgetInstanceModel',['underscore','jquery','WidgetInstanceModel','app'],function(_, $,WidgetInstanceModel,app){
    var _POSTS_PER_LOAD_ = 12;
    var _POST_PER_CAROUSEL_SLIDE_ = 6;

    return WidgetInstanceModel.extend({
        getPosts: function () {
            //console.log('get Instagram Posts', this.p('instagramCatId'));
            var posts, instagramCategory = app.getInstagramCategory(this.p('instagramCatId'));
            if(instagramCategory){
                posts = instagramCategory.getPosts();
            }else{
                posts = _([]);
            }
            return posts;
        },
        getCart: function () {
            // TODO cette référence est là par défaut
            return app.getCart();
        },
        isLogged: function () {
            return app.getCustomer().isLogged();
        },
        getPostsPerLoad: function () {
            return _POSTS_PER_LOAD_;
        },
        requireCarouselPagination:function(){
          return this.getPosts().size() > _POST_PER_CAROUSEL_SLIDE_;
        },
        getCarouselSlides:function(){
            var posts = this.getPosts();
            var slides = [], slide, wrapped;
            posts.each(function(post,index){
                var internal_index = index % _POST_PER_CAROUSEL_SLIDE_;
                if(internal_index === 0){
                    if(!!slide) slides.push(slide);
                    wrapped = _([]);
                    slide = {
                        wrapped : wrapped
                    };
                }
                switch(internal_index){
                    case 0 :
                        slide.firstPost = post;
                        break;
                    case 5:
                        slide.latestPost = post;
                        break;
                    default:
                        wrapped.push(post);
                }
                post.set('index',index);
            });
            if(slide){
                slides.push(slide);
            }
            // placeholder
            _(slides).each(function(slide){
               if(!slide.latestPost){
                   slide.latestPost = 'placeholder';
               }
               while(slide.wrapped.size()<4){
                   slide.wrapped.push('placeholder');
               }
            });
            return _(slides);
        }
    })
})
;
